const orderedTag = (tag) => {
  var n = 10;
  switch (tag) {
    case "Top":
      n = "01";
      break;

    case "High":
      n = "02";
      break;

    case "Mid":
      n = "03";
      break;

    case "Low":
      n = "04";
      break;

    case "FA":
      n = "01";
      break;

    case "GA":
      n = "02";
      break;

    case "A":
      n = "03";
      break;

    case "B":
      n = "04";
      break;

    case "C":
      n = "05";
      break;

    case "Start":
      n = "06";
      break;

    case "Stub":
      n = "07";
      break;

    case "FL":
      n = "08";
      break;

    case "List":
      n = "09";
      break;

    case "High-res":
      n = "01";

    case "Mid-res":
      n = "02";

    case "Low-res":
      n = "03";

    default:
      n = "10";
      break;
  }
  return n + tag;
};

export default orderedTag;
